import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Thermometer, Wheat, Factory, BookMarked } from 'lucide-react';
const bonuses = [{
  number: 'BONO 1',
  title: 'Guía Maestra de Inocuidad y Seguridad Alimentaria',
  subtitle: 'BPM, Contaminación, ETA, Limpieza, Sanitización, HACCP y Control de Riesgos',
  icon: <ShieldCheck size={24} data-id="element-19" data-mp="1yet6tz20qj74" />,
  color: 'text-petrol',
  bg: 'bg-petrol/10',
  purpose: 'Un recurso completo para profundizar en uno de los pilares más importantes de la tecnología de los alimentos: la producción segura. Explica de manera clara y aplicada cómo prevenir riesgos durante la manipulación, elaboración, almacenamiento y conservación.',
  types: ['Buenas Prácticas de Manufactura (BPM)', 'Contaminación física, química, biológica y cruzada', 'Higiene personal y salud del manipulador', 'Limpieza, sanitización y control de materias primas', 'Almacenamiento, manejo de temperaturas y prevención de ETA', 'Codex Alimentarius, trazabilidad y análisis de peligros'],
  result: 'Transformás la inocuidad en un criterio permanente de trabajo dentro del aula-taller. Incluye ejemplos, errores frecuentes y situaciones prácticas para entender por qué un alimento puede verse bien y, aun así, no ser seguro.'
}, {
  number: 'BONO 2',
  title: 'Manual Completo de Métodos de Conservación de Alimentos',
  subtitle: 'Calor, Frío, Deshidratación, Salado, Azucarado, Acidificación, pH, Actividad de Agua y Vida Útil',
  icon: <Thermometer size={24} data-id="element-20" data-mp="1vueh85mhkg5l" />,
  color: 'text-terracota',
  bg: 'bg-terracota/10',
  purpose: 'Una guía especializada para comprender la ciencia detrás de la conservación: por qué los alimentos se deterioran y cómo cada tecnología permite controlar microorganismos y extender la vida útil.',
  types: ['Pasteurización, esterilización y escaldado', 'Refrigeración, congelación, deshidratación y secado', 'Salado, curado, conservación por azúcar y acidificación', 'Fermentación, vacío y combinación de barreras', 'Variables críticas: pH, actividad de agua, temperatura, oxígeno y tiempo'],
  result: 'Cada método se explica desde su principio de funcionamiento, aplicaciones, ventajas, limitaciones y efecto sobre el producto final, con comparaciones entre técnicas y criterios para elegir la más adecuada según el alimento.'
}, {
  number: 'BONO 3',
  title: 'Enciclopedia de Materias Primas y Calidad Alimentaria',
  subtitle: 'Selección, Recepción, Evaluación Sensorial, Almacenamiento, Deterioro y Control de Calidad',
  icon: <Wheat size={24} data-id="element-21" data-mp="177c1gmpcpgka" />,
  color: 'text-olive',
  bg: 'bg-olive/10',
  purpose: 'Un manual de consulta para comprender cómo la calidad de un producto comienza mucho antes del procesamiento. Desarrolla las características de las materias primas usadas en la industria alimentaria.',
  types: ['Frutas, verduras, cereales, harinas y agua', 'Leche, carnes, huevos, grasas, azúcares, sal y especias', 'Selección, evaluación del estado y detección de defectos', 'Condiciones correctas de recepción y almacenamiento', 'Análisis sensorial: apariencia, color, aroma y textura', 'Trazabilidad, control de proveedores y aditivos'],
  result: 'El estudiante aprende a observar y evaluar una materia prima con criterio técnico, comprendiendo que una mala selección inicial puede comprometer todo el proceso posterior.'
}, {
  number: 'BONO 4',
  title: 'Procesos Alimentarios Explicados Paso a Paso',
  subtitle: 'Transformación, Fermentación, Pasteurización, Lácteos, Cárnicos, Conservas, Envasado y Control de Procesos',
  icon: <Factory size={24} data-id="element-22" data-mp="ecvz9e7f0ygr" />,
  color: 'text-green',
  bg: 'bg-green/10',
  purpose: 'Un recurso pensado para que docentes y estudiantes comprendan qué ocurre realmente durante la transformación de los alimentos, con una lógica clara: objetivo → principio tecnológico → variables críticas → posibles fallas → impacto en el producto final.',
  types: ['Recepción, selección, lavado, molienda y mezclado', 'Calentamiento, cocción, pasteurización y concentración', 'Fermentación, coagulación, deshidratación y enfriamiento', 'Congelación, envasado y almacenamiento', 'Yogur, quesos, dulce de leche, embutidos y productos cárnicos', 'Mermeladas, conservas, encurtidos y alimentos fermentados'],
  result: 'El estudiante no memoriza pasos de una receta: comprende qué está ocurriendo en cada etapa y por qué. Un bono de gran valor para conectar teoría, proceso y resultado final.'
}, {
  number: 'BONO 5',
  title: 'Diccionario Profesional de Tecnología de los Alimentos',
  subtitle: 'Más de 200 conceptos técnicos explicados de forma clara y aplicada',
  icon: <BookMarked size={24} data-id="element-23" data-mp="27uuzz52kosgk" />,
  color: 'text-gold',
  bg: 'bg-gold/10',
  purpose: 'Un recurso de consulta rápida para docentes y estudiantes que necesitan comprender el lenguaje técnico de la tecnología alimentaria sin definiciones complicadas. Cada término se explica con definición clara → importancia → ejemplo de aplicación.',
  types: ['Inocuidad, BPM, HACCP y Codex Alimentarius', 'pH, actividad de agua, vida útil y trazabilidad', 'Pasteurización, esterilización, fermentación y congelación', 'Contaminación cruzada, ETA, aditivos y análisis sensorial', 'Envases, rotulado, costos, valor agregado y comercialización', 'Conceptos organizados por grandes áreas para consulta en clase'],
  result: 'El complemento ideal para resolver dudas técnicas rápidamente durante una clase y acompañar toda la colección principal.'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-green" data-id="element-24" data-mp="3hu5qmrokly7k">
      <div className="max-w-6xl mx-auto" data-id="element-25" data-mp="3mrfpexxunm82">
        <div className="text-center mb-16" data-id="element-26" data-mp="3msh2t92c8ksy">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-cream mb-4" data-id="element-27" data-mp="3eqzycktvhhm3">
            5 bonos incluidos sin costo extra
          </h2>
          <p className="text-xl text-cream-light opacity-80" data-id="element-28" data-mp="3aqg1lid7og0h">
            Seguridad · Conservación · Calidad · Procesos · Lenguaje técnico
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-29" data-mp="3jqci2wpg68kg">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: Math.min(index, 3) * 0.08
        }} className={`bg-warmwhite rounded-2xl p-8 relative shadow-lg flex flex-col ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-30" data-mp="1k80r46qb40q" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-gold text-black px-4 py-1 rounded-bl-xl rounded-tr-2xl font-bold text-xs uppercase tracking-wider" data-id="element-31" data-mp="gaxcq8s0kn5n">
                INCLUIDO
              </div>

              <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-6 ${bonus.bg} ${bonus.color}`} data-id="element-32" data-mp="13w7rnwwfxz8l">
                {bonus.icon}
              </div>

              <span className="text-xs font-bold text-slate tracking-widest block mb-2" data-id="element-33" data-mp="uui1svi7j8cx">
                {bonus.number}
              </span>

              <h3 className="text-xl font-bold text-green mb-2 pr-16" data-id="element-34" data-mp="kxn1q86aczwj">
                {bonus.title}
              </h3>

              <p className={`text-sm font-medium mb-5 ${bonus.color}`} data-id="element-35" data-mp="779u66xb3n7q">
                {bonus.subtitle}
              </p>

              <p className="text-ink text-sm mb-5" data-id="element-36" data-mp="c6cx9ltq7jd2">{bonus.purpose}</p>

              <div className="mb-6" data-id="element-37" data-mp="3tdf4cp3vf5i1">
                <span className="text-xs font-bold text-slate uppercase tracking-wider block mb-2" data-id="element-38" data-mp="3te8c9tekg11r">
                  Desarrolla:
                </span>
                <ul className={`space-y-1 ${index === 4 ? 'md:grid md:grid-cols-2 md:gap-x-8 md:space-y-0' : ''}`} data-id="element-39" data-mp="hpx6rq387k96">
                  {bonus.types.map((type, i) => <li key={i} className="flex items-start gap-2 text-sm text-ink py-0.5" data-id="element-40" data-mp="8o7cmchym77p" data-mpi={i}>
                      <span className={bonus.color} data-id="element-41" data-mp="3rqfisss8iih">✓</span>
                      <span data-id="element-42" data-mp="3uwytyt7i62zp">{type}</span>
                    </li>)}
                </ul>
              </div>

              <div className="bg-cream p-4 rounded-xl border border-cream-dark mt-auto" data-id="element-43" data-mp="3q3xg8oj189hp">
                <span className="text-xs font-bold text-green uppercase tracking-wider block mb-1" data-id="element-44" data-mp="3m450nrv8132u">
                  Resultado:
                </span>
                <p className="text-ink text-sm font-medium" data-id="element-45" data-mp="3c560kxoiufrg">{bonus.result}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 max-w-3xl mx-auto text-center bg-green-dark rounded-2xl p-8 border border-gold/30" data-id="element-46" data-mp="376w6yrig3n7y">
          <p className="text-cream text-lg leading-relaxed" data-id="element-47" data-mp="2x4ihija1619e">
            En conjunto, los 5 bonos amplían el sistema con cinco áreas clave:{' '}
            <strong className="text-gold" data-id="element-48" data-mp="37027yq5ts7qr">
              Seguridad + Conservación + Calidad + Procesos + Lenguaje Técnico.
            </strong>
          </p>
          <p className="text-cream-light opacity-80 mt-4" data-id="element-49" data-mp="3bxlxim7z46y0">
            No recibís solo los tomos principales: recibís un ecosistema de
            apoyo completo para comprender, explicar y aplicar mejor cada tema.
          </p>
        </div>
      </div>
    </section>;
}